<template>
  <div class="sui-datepicker">
    <picker
      ref="datepicker"
      :model-value="modelValue"
      :class="{'dp--inline': inline, 'dp--multi-calendars': isRangeMode}"
      v-bind="pickerProps"
      @update:model-value="onPickerUpdate"
    >
      <template #dp-input>
        <div v-if="rangeType === 'separated'" class="sui-datepicker__range-wrap" @click.stop>
          <div class="sui-datepicker-input">
            <input v-maska="maskConfig" class="sui-datepicker-input__control" :class="inputClasses" type="text"
              :name="`${name}_start`" :value="innerValue[0]" autocomplete="off" :disabled="disabled"
              placeholder="placeholder" @input="onInput($event, 'start')" />
            <label v-if="label" class="sui-datepicker-input__label">{{ label[0] }}</label>
            <div class="sui-datepicker-input__btns-wrap">
              <button v-show="btnClearVisible" class="sui-datepicker-input__btn-clear" type="button"
                @click.stop="clear">
                <svg class="sui-datepicker-input__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  fill="none" viewBox="0 0 24 24">
                  <g clip-path="url(#a)">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="m18 6.356-12 12m12 0-12-12" />
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h24v24H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button v-show="!disabled" class="sui-datepicker-input__btn-calendar" type="button" @click="onBtnCalendarClick">
                <svg class="sui-datepicker-input__icon" viewBox="0 0 22 22" width="24" height="24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.667 1.833V5.5M7.333 1.833V5.5M2.75 8.25h16.5M17.417 3.667H4.583c-1.013 0-1.833.82-1.833 1.833v11.917c0 1.013.82 1.833 1.833 1.833h12.834c1.013 0 1.833-.82 1.833-1.833V5.5c0-1.013-.82-1.833-1.833-1.833Z"
                    stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M6.413 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 6.413 11ZM10.996 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM10.996 11a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 15.58 11ZM6.413 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
          <div class="sui-datepicker-input">
            <input v-maska="maskConfig" class="sui-datepicker-input__control" :class="inputClasses" type="text"
              :name="`${name}_end`" :value="innerValue[1]" autocomplete="off" :disabled="disabled"
              placeholder="placeholder" @input="onInput($event, 'end')" />
            <label v-if="label" class="sui-datepicker-input__label">{{ label[1] }}</label>
            <div class="sui-datepicker-input__btns-wrap">
              <button v-show="btnClearVisible" class="sui-datepicker-input__btn-clear" @click.stop="clear">
                <svg class="sui-datepicker-input__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  fill="none" viewBox="0 0 24 24">
                  <g clip-path="url(#a)">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="m18 6.356-12 12m12 0-12-12" />
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h24v24H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button v-show="!disabled" class="sui-datepicker-input__btn-calendar" @click="onBtnCalendarClick">
                <svg class="sui-datepicker-input__icon" viewBox="0 0 22 22" width="24" height="24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.667 1.833V5.5M7.333 1.833V5.5M2.75 8.25h16.5M17.417 3.667H4.583c-1.013 0-1.833.82-1.833 1.833v11.917c0 1.013.82 1.833 1.833 1.833h12.834c1.013 0 1.833-.82 1.833-1.833V5.5c0-1.013-.82-1.833-1.833-1.833Z"
                    stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M6.413 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 6.413 11ZM10.996 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM10.996 11a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 15.58 11ZM6.413 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833Z"
                    fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="sui-datepicker-input" @click.stop>
          <input v-maska="maskConfig" class="sui-datepicker-input__control" :class="inputClasses" type="text"
            :name="name" :value="innerValue" autocomplete="off" :disabled="disabled" placeholder="placeholder"
            @input="onInput($event)" />
          <label v-if="label" class="sui-datepicker-input__label">
            {{ label }}<span v-if="required" class="required-indicator">*</span>
          </label>
          <div class="sui-datepicker-input__btns-wrap">
            <button v-show="btnClearVisible" class="sui-datepicker-input__btn-clear" type="button" @click.stop="clear">
              <svg class="sui-datepicker-input__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="none" viewBox="0 0 24 24">
                <g clip-path="url(#a)">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="m18 6.356-12 12m12 0-12-12" />
                </g>
                <defs>
                  <clipPath id="a">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button v-show="!disabled && !inline" class="sui-datepicker-input__btn-calendar" type="button" @click="onBtnCalendarClick">
              <svg class="sui-datepicker-input__icon" viewBox="0 0 22 22" width="24" height="24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.667 1.833V5.5M7.333 1.833V5.5M2.75 8.25h16.5M17.417 3.667H4.583c-1.013 0-1.833.82-1.833 1.833v11.917c0 1.013.82 1.833 1.833 1.833h12.834c1.013 0 1.833-.82 1.833-1.833V5.5c0-1.013-.82-1.833-1.833-1.833Z"
                  stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M6.413 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 6.413 11ZM10.996 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM10.996 11a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833ZM15.58 11a.917.917 0 1 0 .008 1.833A.917.917 0 0 0 15.58 11ZM6.413 14.667a.917.917 0 1 0 .008 1.833.917.917 0 0 0-.008-1.833Z"
                  fill="currentColor" />
              </svg>
            </button>
          </div>
        </div>
      </template>
      <template #arrow-left>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 8.00003L10 12L14 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
      <template #arrow-right>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 16L14 12L10 8.00003" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
      <template #calendar-icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 2V6M8 2V6M3 9H21M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.99601 12C6.44402 12 5.99603 12.448 6.00003 13C6.00003 13.552 6.44802 14 7.00001 14C7.55201 14 8 13.552 8 13C8 12.448 7.55201 12 6.99601 12Z" fill="currentColor"/>
          <path d="M11.996 16C11.444 16 10.996 16.448 11 17C11 17.552 11.448 18 12 18C12.552 18 13 17.552 13 17C13 16.448 12.552 16 11.996 16Z" fill="currentColor"/>
          <path d="M11.996 12C11.444 12 10.996 12.448 11 13C11 13.552 11.448 14 12 14C12.552 14 13 13.552 13 13C13 12.448 12.552 12 11.996 12Z" fill="currentColor"/>
          <path d="M16.996 16C16.444 16 15.996 16.448 16 17C16 17.552 16.448 18 17 18C17.552 18 18 17.552 18 17C18 16.448 17.552 16 16.996 16Z" fill="currentColor"/>
          <path d="M16.996 12C16.444 12 15.996 12.448 16 13C16 13.552 16.448 14 17 14C17.552 14 18 13.552 18 13C18 12.448 17.552 12 16.996 12Z" fill="currentColor"/>
          <path d="M6.99601 16C6.44402 16 5.99603 16.448 6.00003 17C6.00003 17.552 6.44802 18 7.00001 18C7.55201 18 8 17.552 8 17C8 16.448 7.55201 16 6.99601 16Z" fill="currentColor"/>
        </svg>
      </template>
      <template #clock-icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6408 16.0001L11.7188 13.0641V6.73608" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
    </picker>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed, ref } from 'vue'
import picker from '@vuepic/vue-datepicker';
import type { DatePickerInstance, VueDatePickerProps } from "@vuepic/vue-datepicker"
import '@vuepic/vue-datepicker/dist/main.css'
import './date-picker.scss';
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { vMaska } from 'maska/vue'
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

enum OpenPosition {
  center = 'center',
  left = 'left',
  right = 'right',
}

const props = defineProps({
  lang: {
    type: String as PropType<string>,
    default: 'ru'
  },
  displayFormat: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    dafault: false
  },
  pickerType: {
    type: String as PropType<'date' | 'datetime'>,
    required: true
  },
  valueType: {
    type: String as PropType<'ISODate' | 'ISODateTime'>,
    required: true
  },
  rangeType: {
    type: String as PropType<'no-range' | 'range' | 'separated'>,
    default: 'no-range'
  },
  modelValue: {
    type: [String, Array] as PropType<string | [string, string]>,
    default: '',
  },
  label: {
    type: [Array<string>, String],
    default: '',
    required: true
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  hasErrors: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true
  },
  inline: {
    type: [Boolean, Object] as PropType<boolean | {input: true}>,
    default: false
  },
  minDate: {
    type: String,
    required: false
  },
  maxDate: {
    type: String,
    requred: false
  },
  preventMinMaxNavigation: {
    type: Boolean,
    default: false
  },
  timePickerInline: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'blur', 'focus'])

const pickerProps = computed(() => {
  const propsObj: VueDatePickerProps = {
    name: props.name,
    position: OpenPosition.left,
    offset: 4,
    modelType: 'yyyy-MM-dd',
    range: isRangeMode.value,
    multiCalendars: isRangeMode.value,
    autoApply: true,
    enableTimePicker: ['time', 'datetime'].includes(props.pickerType),
    clearable: false,
    inline: props.inline,
    locale: props.lang,
    disabled: props.disabled,
    readonly: props.readonly,
    monthChangeOnScroll: false,
    preventMinMaxNavigation: props.preventMinMaxNavigation,
    minDate: props.minDate,
    maxDate: props.maxDate,
    timePickerInline: props.timePickerInline,
  }
  if (props.valueType === 'ISODateTime') propsObj.modelType = 'iso'

  return propsObj
})

// computed
const isRangeMode = computed(() => ['range', 'separated'].includes(props.rangeType))

const maskConfig = computed(() => {
  const rawMask = props.displayFormat.replace(/\w/g, '#')
  const mask = props.rangeType === 'range' ? `${rawMask} - ${rawMask}` : rawMask
  return { mask, eager: true }
})

const innerValue = computed(() => Array.isArray(props.modelValue) ? props.modelValue.map(getInnerValue) : getInnerValue(props.modelValue))

const btnClearVisible = computed(() => {
  const hasValue = Array.isArray(props.modelValue) ? props.modelValue.every(v => v !== '') : props.modelValue !== ''
  return !props.disabled && hasValue
})

const inputClasses = computed(() => {
  return {
    'has-errors': props.hasErrors,
    'readonly': props.readonly,
    'disabled': props.disabled
  }
})

const datepicker = ref<DatePickerInstance | null>(null)

// const pickerInstance = computed(() => {
//   return datepicker as DatePickerInstance
// })



// methods
function onBtnCalendarClick() {
  if (datepicker.value) datepicker.value.openMenu()
}

function onPickerUpdate(value: any) {
  emit('update:modelValue', value)
}

function clear() {
  emit('update:modelValue', isRangeMode.value ? ['', ''] : '')
}

function onInput(evt: Event, separateInputId?: string) {
  if (!evt.isTrusted || !evt.target) return
  const { value } = evt.target as HTMLInputElement
  if (value.length === 0) {
    clear()
    return
  }
  if (value.length < maskConfig.value.mask.length) return
  let payload;
  const minDate = props.minDate ? dayjs(props.minDate) : null
  const maxDate = props.maxDate ? dayjs(props.maxDate) : null

  switch (props.rangeType) {
    case 'no-range': {
      let date: dayjs.Dayjs = dayjs(value, props.displayFormat)
      if (!date.isValid()) return
      if (minDate && date.isBefore(minDate)) date = minDate
      if (maxDate && date.isAfter(maxDate)) date = maxDate
      payload = getOuterValue(date)
      break
    }
    case 'separated': {
      let date: dayjs.Dayjs = dayjs(value, props.displayFormat)
      if (!date.isValid()) return
      if (separateInputId === 'start' && minDate && date.isBefore(minDate)) date = minDate
      if (separateInputId !== 'start' && maxDate && date.isAfter(maxDate)) date = maxDate
      const updatedValue = getOuterValue(date)
      payload = separateInputId === 'start' ? [updatedValue, props.modelValue[1]] : [props.modelValue[0], updatedValue]
      break
    }
    case 'range': {
      const dates: dayjs.Dayjs[] = value.split('-').map(v => dayjs(v.trim(), props.displayFormat))
      if (dates.some(date => !date.isValid())) return
      if (minDate && dates[0].isBefore(minDate)) dates[0] = minDate
      if (maxDate && dates[1].isAfter(maxDate)) dates[1] = maxDate
      payload = dates.map(getOuterValue)
      break
    }
  }
  emit('update:modelValue', payload)
}

function getInnerValue(value: string) {
  switch (props.valueType) {
    case 'ISODate':
      return dayjs(value).format(props.displayFormat)
    case 'ISODateTime':
      return dayjs(value).format(props.displayFormat)
    default:
      console.error('Unknow value type!')
      return dayjs(value).format(props.displayFormat)
  }
}

function getOuterValue(dayJsInstance: dayjs.Dayjs) {
  switch (props.valueType) {
    case 'ISODateTime':
      return dayJsInstance.toISOString()
    case 'ISODate':
      return dayJsInstance.format('YYYY-MM-DD')
    default:
      return dayJsInstance.toISOString()
  }
}
</script>

<style
  lang="scss"
  scoped
>
@import '@/assets/styles/scss/mixins.scss';

.required-indicator {
  color: var(--color-text-accent);
}
.sui-datepicker {
  width: 100%;
  position: relative;

  &__icon-calendar {
    cursor: pointer;
    width: 24px;
    height: 24px;
    color: var(--color-icon-primary);

    svg {
      width: 100%;
      height: 100%;
    }

    &.disabled {
      svg {
        color: var(--color-icon-secondary);
      }
    }
  }

  &__icon-clear {
    cursor: pointer;
    width: 24px;
    height: 24px;
    color: var(--color-icon-primary);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  &__range-wrap {
    width: 100%;
    display: flex;
    gap: 20px;
  }
}

.sui-datepicker-input {
  display: flex;
  width: 100%;
  position: relative;

  &__label {
    font-size: 14px;
    line-height: 20px;
    left: 16px;
    top: 16px;
    pointer-events: none;
    position: absolute;
    margin-bottom: 0;
    transform-origin: left;
    color: var(--color-text-tertiary);
    transition: all 0.2s ease-in-out;
    transition-delay: 0.1s;

    .sui-datepicker-input__control:focus+& {
      top: 8px;
      font-size: 12px;
      line-height: 16px;
    }

    .sui-datepicker-input__control:not(:placeholder-shown)+& {
      top: 8px;
      font-size: 12px;
      line-height: 16px;
    }

  }

  &__control {
    width: 100%;
    padding: 24px 104px 8px 16px;
    border: 1px solid var(--stroke-select);
    background-color: var(--color-bg-primary);
    font-family: inherit;
    color: inherit;
    font-size: 14px;
    line-height: 20px;
    border-radius: 4px;

    &:focus {
      outline: none;
      border-color: var(--color-lbutton-light);
    }

    &:hover:not(:disabled) {
      outline: none;
      border-color: var(--color-lbutton-light);
    }

    &:disabled {
      background-color: var(--color-button-disabled);
      color: var(--color-text-secondary);
    }

    &.has-errors {
      outline: none;
      border-color: var(--color-icon-error);
    }

    &[readonly] {
      pointer-events: none;
    }

    &::placeholder {
      opacity: 0
    }
  }

  &__btns-wrap {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  &__btn-calendar {
    @include button-reset;
    height: 24px;
    width: 24px;
    vertical-align: 0;
    fill: transparent;
    overflow: hidden;
  }

  &__btn-clear {
    @include button-reset;
  }

  &__icon {
    height: 24px;
    width: 24px;
    vertical-align: 0;
    fill: transparent;
    overflow: hidden;
  }
}
</style>
